import React from 'react';

import Text from 'common/components/Text/Text';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import { useMediaQuery } from 'react-responsive';
import {
  BannerDots,
  BigUnderlineIcon,
  MouseIcon,
  ProfilingIcon,
  UnderlineShine,
} from 'assets/explore';
import { useNavigate } from 'react-router-dom';

export const ProfilingBanner = (): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const navigate = useNavigate();
  return (
    <div
      className={styles.sectionContainer}
      style={!isMobile ? { marginTop: '32px', marginBottom: '38px' } : undefined}
    >
      <div className={styles.profilingContainer}>
        {!isMobile && <img src={BannerDots} className={styles.bannerDots}></img>}
        <Text
          size={isMobile ? 16 : 20}
          weight={600}
          inlineStyle={
            isMobile
              ? {
                  color: '#19234F',
                  maxWidth: '60%',
                }
              : { display: 'flex', flexDirection: 'column', color: '#19234F', maxWidth: 'inherit' }
          }
        >
          {`Unify help you to find the right programs!`}
          {!isMobile && <img src={BigUnderlineIcon} className={styles.bigUnderline}></img>}
          <img src={UnderlineShine} className={styles.underlineIcon}></img>
        </Text>
        <div className="d-flex flex-row align-items-center gap-2">
          <button
            className={`btn btn-primary btn-lg ${styles.matchingButton}`}
            onClick={() => navigate('/profile')}
          >
            Start
          </button>
          {!isMobile && <img src={MouseIcon} style={{ marginTop: '20px' }}></img>}
        </div>
        <img src={ProfilingIcon} className={styles.profilingIcon}></img>
      </div>
    </div>
  );
};
